import actions from '../../actionTypes';

export default (site,save) => {
  return {
    type: actions.SET_CURRENT_SITE,
    site,
    save
  };
};



// WEBPACK FOOTER //
// ./src/reducers/sites/actions/setCurrentSite.js